export function buildRackLocation({
  locationDetails,
  locationName,
  isMobileLocation,
  subQty = 1,
}) {
  const warehouse = locationDetails?.warehouse;
  const warehouseId = warehouse?.id;
  const warehouseCode = warehouse?.warehouseId || warehouse?.warehouse_id;

  if (!warehouseId || !warehouseCode || !locationDetails?.id) {
    return null;
  }

  const common = {
    sub_qty: subQty,
    allocated_quantity: 0,
    warehouse: {
      id: warehouseId,
      warehouse_id: warehouseCode,
      name: warehouse?.name,
    },
  };

  if (isMobileLocation) {
    return {
      ...common,
      mobile_warehouse_location: {
        id: locationDetails.id,
        location_id: locationDetails.locationId || locationDetails.location_id,
        location_name: locationDetails.locationName || locationName,
      },
    };
  }

  return {
    ...common,
    warehouse_locations: [
      {
        id: locationDetails.id,
        location_id: locationDetails.locationId || locationDetails.location_id,
        location_name: locationDetails.locationName || locationName,
      },
    ],
  };
}
